import styled from 'styled-components';

export const AdvancedInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.margin}px;
  padding: 0 ${({ theme: { token } }) => token.padding}px;

  .value {
    word-break: break-all;
  }
`;
